import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "fs-2 text-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_10 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("PMA Reminder for ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_13 = /*#__PURE__*/_createVNode("a", {
  class: "btn btn-sm btn-danger me-3",
  href: "#/estore"
}, "complete your maintenance NOW", -1)
const _hoisted_14 = {
  key: 0,
  class: "dashboardFontStyle mb-2"
}
const _hoisted_15 = { class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "fs-2 text-gray-600" }
const _hoisted_20 = { class: "dashboardFontStyle mb-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_22 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = { class: "fs-2 text-gray-600" }
const _hoisted_28 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_30 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("New PMA Redemption Schedule")
const _hoisted_32 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode("           In our ongoing efforts to enhance system performance and ensure a smooth and efficient experience for all users, we are implementing a new policy regarding the encoding of PMA points. This policy aims to distribute system load more evenly throughout the month, thereby reducing traffic congestion during peak periods. ")
const _hoisted_34 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode("           1) Gold Executives and Global Ambassadors must encode their PMA from the 1st to the 15th of each month. ")
const _hoisted_36 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("                     Example: June 1 to 15, 2024 ")
const _hoisted_38 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("           2) Silver Executives and New Distributors must encode their PMA from the 1st to the 29th of each month. ")
const _hoisted_40 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode("                     Example: June 1 to 29, 2024 ")
const _hoisted_42 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode("           *** No PMA encoding during the 30th and 31st of the month. *** ")
const _hoisted_44 = {
  key: 1,
  class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6"
}
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "fw-bold" }
const _hoisted_48 = { class: "fs-2 text-gray-600" }
const _hoisted_49 = { class: "dashboardFontStyle mb-2" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_51 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Cheque encashment for Uganda is temporarily unavailable. ")
const _hoisted_53 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_54 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_55 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Starting Oct 10, 2024, we shall have cashless transactions in all our branches. We shall only accept bank payments. You may deposit your payments at: ")
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-md-6 mt-3 mb-3" }
const _hoisted_59 = {
  class: "dashboardFontStyle mb-2 text-center",
  align: "justify"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("b", null, "STANBIC", -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode()
const _hoisted_62 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" 9030010927810")
const _hoisted_64 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" ALLIANCE IN MOTION GLOBAL (UGANDA) L ")
const _hoisted_66 = { class: "col-md-6 mb-3" }
const _hoisted_67 = {
  class: "dashboardFontStyle mb-2 text-center",
  align: "justify"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("b", null, "ECOBANK", -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode()
const _hoisted_70 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" 7170002437")
const _hoisted_72 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" ALLIANCE IN MOTION GLOBAL UGANDA LT ")
const _hoisted_74 = {
  key: 2,
  class: "row"
}
const _hoisted_75 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("img", {
  src: "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_MOBILE.jpg",
  height: "370"
}, null, -1)
const _hoisted_77 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("img", { src: "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_PC.jpg" }, null, -1)
const _hoisted_79 = {
  key: 3,
  class: "row"
}
const _hoisted_80 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_81 = /*#__PURE__*/_createVNode("img", {
  src: "https://images.empoweredconsumerism-static-files.com/ecp/BDO_MC_Advisory_MOBILE.jpg",
  height: "370"
}, null, -1)
const _hoisted_82 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_83 = /*#__PURE__*/_createVNode("img", { src: "https://images.empoweredconsumerism-static-files.com/ecp/BDO_MC_Advisory_PC.jpg" }, null, -1)
const _hoisted_84 = { class: "notice bg-light-success rounded border-success border border-dashed mb-3 mt-3 p-6" }
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_86 = { class: "row" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "fw-bold" }
const _hoisted_89 = { class: "fs-2 text-gray-600" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_91 = { class: "svg-icon svg-icon-3tx svg-icon-success me-4" }
const _hoisted_92 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createTextVNode("OOTD MNL Hoodies will now be available! "),
  /*#__PURE__*/_createVNode("a", {
    class: "",
    href: "#/hoodiejacket"
  }, [
    /*#__PURE__*/_createVNode("u", null, "Click here")
  ]),
  /*#__PURE__*/_createTextVNode(" to select your preferred design. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_font = _resolveComponent("font")

  return (_ctx.pt != 'bibo' && _ctx.pt != 'ecc'  && _ctx.pt != 'pcp' && _ctx.ecShopAdvisoryVisibility.showComponent)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _withDirectives(_createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("p", null, [
                      _hoisted_9,
                      _createVNode("span", _hoisted_10, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                      ]),
                      _createVNode(_component_font, { class: "fs-2" }, {
                        default: _withCtx(() => [
                          _createVNode("b", null, [
                            _hoisted_11,
                            _createVNode("u", null, _toDisplayString(_ctx.usid), 1),
                            _hoisted_12
                          ])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.unilevelMaintenancePromptMessage1) + " ", 1),
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(_ctx.unilevelMaintenancePromptMessage2), 1)
                    ]),
                    (_ctx.ecp_welcome_data.unilevelMaintenancePromptMessage2 != '')
                      ? (_openBlock(), _createBlock("p", _hoisted_14, "           " + _toDisplayString(_ctx.ecp_welcome_data.unilevelMaintenancePromptMessage2), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isShowPMAWarning]
          ]),
          _withDirectives(_createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("p", _hoisted_20, [
                      _hoisted_21,
                      _createVNode("span", _hoisted_22, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                      ]),
                      _createVNode(_component_font, { size: "5" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.csrMessage), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _hoisted_23
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isEnabledECCSRNotification]
          ]),
          false
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", _hoisted_27, [
                      _createVNode("p", _hoisted_28, [
                        _hoisted_29,
                        _createVNode("span", _hoisted_30, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                        ]),
                        _createVNode("b", null, [
                          _createVNode(_component_font, { class: "fs-1" }, {
                            default: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createVNode("p", _hoisted_32, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_33
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("p", _hoisted_34, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_35
                          ]),
                          _: 1
                        }),
                        _hoisted_36,
                        _hoisted_37
                      ]),
                      _createVNode("p", _hoisted_38, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_39
                          ]),
                          _: 1
                        }),
                        _hoisted_40,
                        _hoisted_41
                      ]),
                      _createVNode("p", _hoisted_42, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createBlock("div", _hoisted_44, [
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, [
                    _createVNode("div", _hoisted_47, [
                      _createVNode("div", _hoisted_48, [
                        _createVNode("p", _hoisted_49, [
                          _hoisted_50,
                          _createVNode("span", _hoisted_51, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _createVNode(_component_font, { size: "5" }, {
                            default: _withCtx(() => [
                              _hoisted_52
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("p", _hoisted_53, [
                          _hoisted_54,
                          _createVNode("span", _hoisted_55, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _createVNode(_component_font, { size: "4" }, {
                            default: _withCtx(() => [
                              _hoisted_56
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("div", _hoisted_57, [
                          _createVNode("div", _hoisted_58, [
                            _createVNode("p", _hoisted_59, [
                              _createVNode(_component_font, { size: "3" }, {
                                default: _withCtx(() => [
                                  _hoisted_60,
                                  _hoisted_61,
                                  _hoisted_62,
                                  _hoisted_63,
                                  _hoisted_64,
                                  _hoisted_65
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createVNode("div", _hoisted_66, [
                            _createVNode("p", _hoisted_67, [
                              _createVNode(_component_font, { size: "3" }, {
                                default: _withCtx(() => [
                                  _hoisted_68,
                                  _hoisted_69,
                                  _hoisted_70,
                                  _hoisted_71,
                                  _hoisted_72,
                                  _hoisted_73
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.ccode == 9)
            ? (_openBlock(), _createBlock("div", _hoisted_74, [
                (_ctx.windowWidth <= 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_75, [
                      _hoisted_76
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth > 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_77, [
                      _hoisted_78
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isShowBDOMastercardAdvisory === true)
            ? (_openBlock(), _createBlock("div", _hoisted_79, [
                (_ctx.windowWidth <= 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_80, [
                      _hoisted_81
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth > 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_82, [
                      _hoisted_83
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("div", _hoisted_84, [
            _hoisted_85,
            _createVNode("div", _hoisted_86, [
              _createVNode("div", _hoisted_87, [
                _createVNode("div", _hoisted_88, [
                  _createVNode("div", _hoisted_89, [
                    _createVNode("p", null, [
                      _hoisted_90,
                      _createVNode("span", _hoisted_91, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                      ]),
                      _createVNode(_component_font, { class: "fs-2" }, {
                        default: _withCtx(() => [
                          _hoisted_92
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isShowHoodiePage == true]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}